<template>
  <autocomplete
    :label="$t('stock')"
    v-model="model"
    :items="warehouses"
    item-text="name"
    item-value="id"
    required
    :return-object="returnObject"
    :hide-details="hideDetails"
    :rules="[rules.required]"
    show-item-slot
    show-selection-slot
    :loading="loading.fetchWarehouses"
    :disabled="loading.fetchWarehouses || disabled"
    :color="color"
  >
    <template v-slot:item="{ item }">{{ translate(item.name) }}</template>
    <template v-slot:selection="{ data }">
      {{ translate(data.item.name) }}
    </template>
  </autocomplete>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import warehouseService from "@/services/warehouse";

export default {
  mixins: [hasModel, hasValidation, hasSnackbar],
  name: "ChooseWarehouseField",
  props: {
    hideDetails: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "default",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      warehouses: [],
      loading: {
        fetchWarehouses: false,
      },
    };
  },
  created() {
    this.fetchWarehouses();
  },
  methods: {
    async fetchWarehouses() {
      if (this.loading.fetchWarehouses) {
        console.warn(
          "Fetch warehouses operation already in progress, skipping duplicate request"
        );
        return;
      }

      this.loading.fetchWarehouses = true;

      try {
        const response = await warehouseService.getWarehouses();
        this.warehouses = response.data;
      } catch (error) {
        console.error("Error fetching warehouses:", error);
        this.showErrorSnackbar(error, this.$t("error_loading_warehouses"));
      } finally {
        this.loading.fetchWarehouses = false;
      }
    },
  },
  computed: {},
};
</script>
